/**
 * DMC 6-Strand Embroidery Floss Color Database
 * Comprehensive list of DMC colors with codes, names, and hex values
 */

export const dmcColors = [
  { code: "blanc", name: "White", hex: "#FFFFFF" },
  { code: "ecru", name: "Ecru", hex: "#F0EAD6" },
  { code: "150", name: "Dusty Rose - Ultra Very Dark", hex: "#AB4E68" },
  { code: "151", name: "Dusty Rose - Very Light", hex: "#F0D9DD" },
  { code: "152", name: "Shell Pink - Medium Light", hex: "#E3A79B" },
  { code: "153", name: "Violet - Very Light", hex: "#E6D7E0" },
  { code: "154", name: "Grape - Very Dark", hex: "#5C3543" },
  { code: "155", name: "Blue Violet - Medium Dark", hex: "#927BBC" },
  { code: "156", name: "Blue Violet - Medium Light", hex: "#A6B4D7" },
  { code: "157", name: "Cornflower Blue - Very Light", hex: "#C0CEE4" },
  { code: "158", name: "Cornflower Blue - Medium Very Dark", hex: "#46495C" },
  { code: "159", name: "Blue Gray - Light", hex: "#B2BBC3" },
  { code: "160", name: "Blue Gray - Medium", hex: "#8A9AA6" },
  { code: "161", name: "Blue Gray", hex: "#7A8D9B" },
  { code: "162", name: "Blue Gray - Ultra Very Light", hex: "#D0DCE5" },
  { code: "163", name: "Celadon Green - Medium", hex: "#4A6B4D" },
  { code: "164", name: "Forest Green - Light", hex: "#AAC597" },
  { code: "165", name: "Moss Green - Very Light", hex: "#E5E874" },
  { code: "166", name: "Moss Green - Medium Light", hex: "#B8A95C" },
  { code: "167", name: "Yellow Beige - Very Dark", hex: "#A0824B" },
  { code: "168", name: "Pewter - Very Light", hex: "#C6C6C6" },
  { code: "169", name: "Pewter - Light", hex: "#858585" },
  { code: "208", name: "Lavender - Very Dark", hex: "#76548E" },
  { code: "209", name: "Lavender - Dark", hex: "#B399CB" },
  { code: "210", name: "Lavender - Medium", hex: "#C8A3D8" },
  { code: "211", name: "Lavender - Light", hex: "#E5DDEA" },
  { code: "221", name: "Shell Pink - Very Dark", hex: "#8B3E4B" },
  { code: "223", name: "Shell Pink - Light", hex: "#C99483" },
  { code: "224", name: "Shell Pink - Very Light", hex: "#E1B4A7" },
  { code: "225", name: "Shell Pink - Ultra Very Light", hex: "#FFE3DC" },
  { code: "300", name: "Mahogany - Very Dark", hex: "#774536" },
  { code: "301", name: "Mahogany - Medium", hex: "#C97E50" },
  { code: "304", name: "Christmas Red - Medium", hex: "#B21A36" },
  { code: "307", name: "Lemon", hex: "#FFD740" },
  { code: "310", name: "Black", hex: "#000000" },
  { code: "311", name: "Navy Blue - Medium", hex: "#1F4788" },
  { code: "312", name: "Navy Blue - Light", hex: "#385E8A" },
  { code: "315", name: "Antique Mauve - Medium Very Dark", hex: "#754D5C" },
  { code: "316", name: "Antique Mauve - Medium", hex: "#C47C8A" },
  { code: "317", name: "Pewter Gray", hex: "#6D6C6D" },
  { code: "318", name: "Steel Gray - Light", hex: "#B3B4B4" },
  { code: "319", name: "Pistachio Green - Very Dark", hex: "#315231" },
  { code: "320", name: "Pistachio Green - Medium", hex: "#688162" },
  { code: "321", name: "Christmas Red", hex: "#CB2230" },
  { code: "322", name: "Navy Blue - Very Light", hex: "#6788AB" },
  { code: "326", name: "Rose - Very Dark", hex: "#C03452" },
  { code: "327", name: "Violet - Dark", hex: "#5B2F63" },
  { code: "333", name: "Blue Violet - Very Dark", hex: "#5C5AA0" },
  { code: "334", name: "Baby Blue - Medium", hex: "#6E9BC5" },
  { code: "335", name: "Rose", hex: "#E74268" },
  { code: "336", name: "Navy Blue", hex: "#1F3A5C" },
  { code: "340", name: "Blue Violet - Medium", hex: "#AC92C9" },
  { code: "341", name: "Blue Violet - Light", hex: "#B5CAE5" },
  { code: "347", name: "Salmon - Very Dark", hex: "#C62E43" },
  { code: "349", name: "Coral - Dark", hex: "#C94349" },
  { code: "350", name: "Coral - Medium", hex: "#DC545A" },
  { code: "351", name: "Coral", hex: "#E45B5F" },
  { code: "352", name: "Coral - Light", hex: "#F08077" },
  { code: "353", name: "Peach", hex: "#FBC3B4" },
  { code: "355", name: "Terra Cotta - Dark", hex: "#984739" },
  { code: "356", name: "Terra Cotta - Medium", hex: "#C07561" },
  { code: "367", name: "Pistachio Green - Dark", hex: "#536D4E" },
  { code: "368", name: "Pistachio Green - Light", hex: "#A5B88A" },
  { code: "369", name: "Pistachio Green - Very Light", hex: "#D7E8A5" },
  { code: "370", name: "Mustard - Medium", hex: "#B38551" },
  { code: "371", name: "Mustard", hex: "#BF935F" },
  { code: "372", name: "Mustard - Light", hex: "#CCAB78" },
  { code: "400", name: "Mahogany - Dark", hex: "#995638" },
  { code: "402", name: "Mahogany - Very Light", hex: "#F6936F" },
  { code: "407", name: "Desert Sand - Dark", hex: "#C29567" },
  { code: "413", name: "Pewter Gray - Dark", hex: "#575757" },
  { code: "414", name: "Steel Gray - Dark", hex: "#8D8D8D" },
  { code: "415", name: "Pearl Gray", hex: "#D3D3D3" },
  { code: "420", name: "Hazelnut Brown - Dark", hex: "#A66D3C" },
  { code: "422", name: "Hazelnut Brown - Light", hex: "#C49A6C" },
  { code: "433", name: "Brown - Medium", hex: "#87543D" },
  { code: "434", name: "Brown - Light", hex: "#996633" },
  { code: "435", name: "Brown - Very Light", hex: "#B67531" },
  { code: "436", name: "Tan", hex: "#D0935F" },
  { code: "437", name: "Tan - Light", hex: "#E8B77D" },
  { code: "444", name: "Lemon - Dark", hex: "#FFB900" },
  { code: "445", name: "Lemon - Light", hex: "#FFDF80" },
  { code: "451", name: "Shell Gray - Dark", hex: "#91938C" },
  { code: "452", name: "Shell Gray - Medium", hex: "#B8B8AF" },
  { code: "453", name: "Shell Gray - Light", hex: "#D0CECA" },
  { code: "469", name: "Avocado Green", hex: "#6B7730" },
  { code: "470", name: "Avocado Green - Light", hex: "#859448" },
  { code: "471", name: "Avocado Green - Very Light", hex: "#A6AA66" },
  { code: "472", name: "Avocado Green - Ultra Light", hex: "#C7D362" },
  { code: "498", name: "Christmas Red - Dark", hex: "#8E1927" },
  { code: "500", name: "Blue Green - Very Dark", hex: "#0F4539" },
  { code: "501", name: "Blue Green - Dark", hex: "#2E5D4F" },
  { code: "502", name: "Blue Green", hex: "#5A866F" },
  { code: "503", name: "Blue Green - Medium", hex: "#7FA889" },
  { code: "504", name: "Blue Green - Very Light", hex: "#C1D7C8" },
  { code: "517", name: "Wedgwood - Dark", hex: "#2D6B7D" },
  { code: "518", name: "Wedgwood - Light", hex: "#4896A8" },
  { code: "519", name: "Sky Blue", hex: "#8FC0D4" },
  { code: "520", name: "Fern Green - Dark", hex: "#5A6652" },
  { code: "522", name: "Fern Green", hex: "#98A29A" },
  { code: "523", name: "Fern Green - Light", hex: "#B4C1B5" },
  { code: "524", name: "Fern Green - Very Light", hex: "#CBD0C8" },
  { code: "535", name: "Ash Gray - Very Light", hex: "#4C4C4C" },
  { code: "543", name: "Beige Brown - Ultra Very Light", hex: "#F0DFD1" },
  { code: "550", name: "Violet - Very Dark", hex: "#5E3A73" },
  { code: "552", name: "Violet - Medium", hex: "#934B9D" },
  { code: "553", name: "Violet", hex: "#A46CA5" },
  { code: "554", name: "Violet - Light", hex: "#D7B5D8" },
  { code: "561", name: "Jade - Very Dark", hex: "#276A51" },
  { code: "562", name: "Jade - Medium", hex: "#3F8A63" },
  { code: "563", name: "Jade - Light", hex: "#9CBB9E" },
  { code: "564", name: "Jade - Very Light", hex: "#C5DEC8" },
  { code: "580", name: "Moss Green - Dark", hex: "#7C8558" },
  { code: "581", name: "Moss Green", hex: "#A3A060" },
  { code: "597", name: "Turquoise", hex: "#5EB3B7" },
  { code: "598", name: "Turquoise - Light", hex: "#A0D5D8" },
  { code: "600", name: "Cranberry - Very Dark", hex: "#CF5481" },
  { code: "601", name: "Cranberry - Dark", hex: "#D4648D" },
  { code: "602", name: "Cranberry - Medium", hex: "#E37899" },
  { code: "603", name: "Cranberry", hex: "#FF7FAF" },
  { code: "604", name: "Cranberry - Light", hex: "#FFB0CD" },
  { code: "605", name: "Cranberry - Very Light", hex: "#FFCFE0" },
  { code: "666", name: "Christmas Red - Bright", hex: "#E71E30" },
  { code: "677", name: "Old Gold - Very Light", hex: "#F4E8B7" },
  { code: "680", name: "Old Gold - Dark", hex: "#C29446" },
  { code: "699", name: "Christmas Green", hex: "#12613D" },
  { code: "700", name: "Christmas Green - Bright", hex: "#177944" },
  { code: "701", name: "Christmas Green - Light", hex: "#4B8E3A" },
  { code: "702", name: "Kelly Green", hex: "#54A04B" },
  { code: "703", name: "Chartreuse", hex: "#7AB858" },
  { code: "704", name: "Chartreuse - Bright", hex: "#A3CA5C" },
  { code: "712", name: "Cream", hex: "#FFFEF2" },
  { code: "718", name: "Plum", hex: "#A93967" },
  { code: "720", name: "Orange Spice - Dark", hex: "#E56328" },
  { code: "721", name: "Orange Spice - Medium", hex: "#F27850" },
  { code: "722", name: "Orange Spice - Light", hex: "#F99870" },
  { code: "725", name: "Topaz", hex: "#FFC955" },
  { code: "726", name: "Topaz - Light", hex: "#FFD866" },
  { code: "727", name: "Topaz - Very Light", hex: "#FFEB9C" },
  { code: "729", name: "Old Gold - Medium", hex: "#D4A956" },
  { code: "730", name: "Olive Green - Very Dark", hex: "#926F3B" },
  { code: "731", name: "Olive Green - Dark", hex: "#A47F41" },
  { code: "732", name: "Olive Green", hex: "#9C8549" },
  { code: "733", name: "Olive Green - Medium", hex: "#CDA85D" },
  { code: "734", name: "Olive Green - Light", hex: "#CCAF76" },
  { code: "738", name: "Tan - Very Light", hex: "#E6C09A" },
  { code: "739", name: "Tan - Ultra Very Light", hex: "#F6E3CF" },
  { code: "740", name: "Tangerine", hex: "#FF8A0B" },
  { code: "741", name: "Tangerine - Medium", hex: "#FFA133" },
  { code: "742", name: "Tangerine - Light", hex: "#FFB359" },
  { code: "743", name: "Yellow - Medium", hex: "#FFD35C" },
  { code: "744", name: "Yellow - Pale", hex: "#FFEB8C" },
  { code: "745", name: "Yellow - Light Pale", hex: "#FFF2BE" },
  { code: "746", name: "Off White", hex: "#FFFBF2" },
  { code: "747", name: "Sky Blue - Very Light", hex: "#E4F4F3" },
  { code: "754", name: "Peach - Light", hex: "#FBD7CE" },
  { code: "758", name: "Terra Cotta - Very Light", hex: "#E8BFB1" },
  { code: "760", name: "Salmon", hex: "#F18E97" },
  { code: "761", name: "Salmon - Light", hex: "#FFC3CB" },
  { code: "762", name: "Pearl Gray - Very Light", hex: "#E5E5E5" },
  { code: "772", name: "Pine Green - Light", hex: "#D1E9A2" },
  { code: "775", name: "Baby Blue - Very Light", hex: "#DFF0F3" },
  { code: "776", name: "Pink - Medium", hex: "#F8B5AC" },
  { code: "777", name: "Raspberry - Very Dark", hex: "#983659" },
  { code: "778", name: "Antique Mauve - Very Light", hex: "#D5B4BB" },
  { code: "780", name: "Topaz - Ultra Very Dark", hex: "#9B5931" },
  { code: "781", name: "Topaz - Very Dark", hex: "#A76D43" },
  { code: "782", name: "Topaz - Dark", hex: "#B98449" },
  { code: "783", name: "Christmas Gold", hex: "#D9A04A" },
  { code: "791", name: "Cornflower Blue - Very Dark", hex: "#475E88" },
  { code: "792", name: "Cornflower Blue - Dark", hex: "#5C779B" },
  { code: "793", name: "Cornflower Blue - Medium", hex: "#7A96BA" },
  { code: "794", name: "Cornflower Blue - Light", hex: "#A4BDD9" },
  { code: "796", name: "Royal Blue - Dark", hex: "#1C3A6B" },
  { code: "797", name: "Royal Blue", hex: "#1E4B87" },
  { code: "798", name: "Delft Blue - Dark", hex: "#5076A1" },
  { code: "799", name: "Delft Blue - Medium", hex: "#789ABD" },
  { code: "800", name: "Delft Blue - Pale", hex: "#C3D9E8" },
  { code: "801", name: "Coffee Brown - Dark", hex: "#5C3D20" },
  { code: "806", name: "Peacock Blue - Dark", hex: "#2C8293" },
  { code: "807", name: "Peacock Blue", hex: "#5FA0AD" },
  { code: "809", name: "Delft Blue", hex: "#92ABD0" },
  { code: "813", name: "Blue - Light", hex: "#ADCDE5" },
  { code: "814", name: "Garnet - Dark", hex: "#8F1934" },
  { code: "815", name: "Garnet - Medium", hex: "#A52041" },
  { code: "816", name: "Garnet", hex: "#B8294E" },
  { code: "817", name: "Coral Red - Very Dark", hex: "#B82E37" },
  { code: "818", name: "Baby Pink", hex: "#FFD7DD" },
  { code: "819", name: "Baby Pink - Light", hex: "#FFEEF0" },
  { code: "820", name: "Royal Blue - Very Dark", hex: "#122C54" },
  { code: "822", name: "Beige Gray - Light", hex: "#E2DDD1" },
  { code: "823", name: "Navy Blue - Dark", hex: "#1C3657" },
  { code: "824", name: "Blue - Very Dark", hex: "#33628F" },
  { code: "825", name: "Blue - Dark", hex: "#3F7498" },
  { code: "826", name: "Blue - Medium", hex: "#5891AC" },
  { code: "827", name: "Blue - Very Light", hex: "#BAD8E3" },
  { code: "828", name: "Blue - Ultra Very Light", hex: "#D6EDF3" },
  { code: "829", name: "Golden Olive - Very Dark", hex: "#866C2E" },
  { code: "830", name: "Golden Olive - Dark", hex: "#9A7D3E" },
  { code: "831", name: "Golden Olive - Medium", hex: "#AE8F4C" },
  { code: "832", name: "Golden Olive", hex: "#BF9F5C" },
  { code: "833", name: "Golden Olive - Light", hex: "#CFAF6F" },
  { code: "834", name: "Golden Olive - Very Light", hex: "#DFC28C" },
  { code: "838", name: "Beige Brown - Very Dark", hex: "#4F3C2D" },
  { code: "839", name: "Beige Brown - Dark", hex: "#5C4A3A" },
  { code: "840", name: "Beige Brown - Medium", hex: "#8D754C" },
  { code: "841", name: "Beige Brown - Light", hex: "#B59B71" },
  { code: "842", name: "Beige Brown - Very Light", hex: "#CFB798" },
  { code: "844", name: "Beaver Gray - Ultra Dark", hex: "#4C4C4C" },
  { code: "869", name: "Hazelnut Brown - Very Dark", hex: "#916342" },
  { code: "890", name: "Pistachio Green - Ultra Dark", hex: "#23462C" },
  { code: "891", name: "Carnation - Dark", hex: "#FF4866" },
  { code: "892", name: "Carnation - Medium", hex: "#FF647F" },
  { code: "893", name: "Carnation - Light", hex: "#FF8CA2" },
  { code: "894", name: "Carnation - Very Light", hex: "#FFB5C4" },
  { code: "895", name: "Hunter Green - Very Dark", hex: "#2F5841" },
  { code: "898", name: "Coffee Brown - Very Dark", hex: "#4C2A1E" },
  { code: "899", name: "Rose - Medium", hex: "#EF607C" },
  { code: "900", name: "Burnt Orange - Dark", hex: "#CF4A21" },
  { code: "902", name: "Garnet - Very Dark", hex: "#892241" },
  { code: "904", name: "Parrot Green - Very Dark", hex: "#5C7D3E" },
  { code: "905", name: "Parrot Green - Dark", hex: "#6A8B40" },
  { code: "906", name: "Parrot Green - Medium", hex: "#86AB5D" },
  { code: "907", name: "Parrot Green - Light", hex: "#BFD866" },
  { code: "909", name: "Emerald Green - Very Dark", hex: "#1D7245" },
  { code: "910", name: "Emerald Green - Dark", hex: "#238252" },
  { code: "911", name: "Emerald Green - Medium", hex: "#2E9860" },
  { code: "912", name: "Emerald Green - Light", hex: "#4FB574" },
  { code: "913", name: "Nile Green - Medium", hex: "#6DB68F" },
  { code: "915", name: "Plum - Dark", hex: "#A3365B" },
  { code: "917", name: "Plum - Medium", hex: "#B84868" },
  { code: "918", name: "Red Copper - Dark", hex: "#7D3829" },
  { code: "919", name: "Red Copper", hex: "#8E4633" },
  { code: "920", name: "Copper - Medium", hex: "#B6633F" },
  { code: "921", name: "Copper", hex: "#C86D49" },
  { code: "922", name: "Copper - Light", hex: "#DB865F" },
  { code: "924", name: "Gray Green - Very Dark", hex: "#4D5C63" },
  { code: "926", name: "Gray Green - Medium", hex: "#7B9EA3" },
  { code: "927", name: "Gray Green - Light", hex: "#B5C7C9" },
  { code: "928", name: "Gray Green - Very Light", hex: "#D7E3E3" },
  { code: "930", name: "Antique Blue - Dark", hex: "#475B6C" },
  { code: "931", name: "Antique Blue - Medium", hex: "#6B7E8C" },
  { code: "932", name: "Antique Blue - Light", hex: "#9FAEB9" },
  { code: "934", name: "Black Avocado Green", hex: "#32412D" },
  { code: "935", name: "Avocado Green - Dark", hex: "#495138" },
  { code: "936", name: "Avocado Green - Very Dark", hex: "#3F4D30" },
  { code: "937", name: "Avocado Green - Medium", hex: "#5B653E" },
  { code: "938", name: "Coffee Brown - Ultra Dark", hex: "#3A1F17" },
  { code: "939", name: "Navy Blue - Very Dark", hex: "#0E2947" },
  { code: "943", name: "Aquamarine - Medium", hex: "#5CAAA4" },
  { code: "945", name: "Tawny", hex: "#F9CDB0" },
  { code: "946", name: "Burnt Orange - Medium", hex: "#E35C2F" },
  { code: "947", name: "Burnt Orange", hex: "#F06C3A" },
  { code: "948", name: "Peach - Very Light", hex: "#FFE8DD" },
  { code: "950", name: "Desert Sand - Light", hex: "#F0D4BC" },
  { code: "951", name: "Tawny - Light", hex: "#FFDFC8" },
  { code: "954", name: "Nile Green", hex: "#A5D37D" },
  { code: "955", name: "Nile Green - Light", hex: "#C1E6B4" },
  { code: "956", name: "Geranium", hex: "#FF7FB1" },
  { code: "957", name: "Geranium - Pale", hex: "#FFB0CC" },
  { code: "958", name: "Sea Green - Dark", hex: "#44B0A0" },
  { code: "959", name: "Sea Green - Medium", hex: "#85D3C6" },
  { code: "961", name: "Dusty Rose - Dark", hex: "#CF5471" },
  { code: "962", name: "Dusty Rose - Medium", hex: "#E98699" },
  { code: "963", name: "Dusty Rose - Ultra Very Light", hex: "#FFD9E0" },
  { code: "964", name: "Sea Green - Light", hex: "#C3E8DF" },
  { code: "966", name: "Baby Green - Medium", hex: "#C1D5AD" },
  { code: "970", name: "Pumpkin - Light", hex: "#FF8A3B" },
  { code: "971", name: "Pumpkin", hex: "#FF7018" },
  { code: "972", name: "Canary - Deep", hex: "#FFB428" },
  { code: "973", name: "Canary - Bright", hex: "#FFD740" },
  { code: "975", name: "Golden Brown - Dark", hex: "#9F6F3D" },
  { code: "976", name: "Golden Brown - Medium", hex: "#D29B5B" },
  { code: "977", name: "Golden Brown - Light", hex: "#DDB575" },
  { code: "986", name: "Forest Green - Very Dark", hex: "#3E7158" },
  { code: "987", name: "Forest Green - Dark", hex: "#508763" },
  { code: "988", name: "Forest Green - Medium", hex: "#6FA070" },
  { code: "989", name: "Forest Green", hex: "#7FB382" },
  { code: "991", name: "Aquamarine - Dark", hex: "#347A6A" },
  { code: "992", name: "Aquamarine", hex: "#5AB4A4" },
  { code: "993", name: "Aquamarine - Light", hex: "#88CCBE" },
  { code: "995", name: "Electric Blue - Dark", hex: "#1F8AAC" },
  { code: "996", name: "Electric Blue - Medium", hex: "#2AAEC7" },
  { code: "3011", name: "Khaki Green - Dark", hex: "#8C7152" },
  { code: "3012", name: "Khaki Green - Medium", hex: "#A79966" },
  { code: "3013", name: "Khaki Green - Light", hex: "#C4B896" },
  { code: "3021", name: "Brown Gray - Very Dark", hex: "#60564E" },
  { code: "3022", name: "Brown Gray - Medium", hex: "#8E8177" },
  { code: "3023", name: "Brown Gray - Light", hex: "#C1BBA8" },
  { code: "3024", name: "Brown Gray - Very Light", hex: "#DEDACF" },
  { code: "3031", name: "Mocha Brown - Very Dark", hex: "#664233" },
  { code: "3032", name: "Mocha Brown - Medium", hex: "#C2A58F" },
  { code: "3033", name: "Mocha Brown - Very Light", hex: "#ECDDC8" },
  { code: "3041", name: "Antique Violet - Medium", hex: "#BFA0C2" },
  { code: "3042", name: "Antique Violet - Light", hex: "#E3CFE5" },
  { code: "3045", name: "Yellow Beige - Dark", hex: "#C79B65" },
  { code: "3046", name: "Yellow Beige - Medium", hex: "#E4BA8B" },
  { code: "3047", name: "Yellow Beige - Light", hex: "#FFDFBD" },
  { code: "3051", name: "Green Gray - Dark", hex: "#5E6A52" },
  { code: "3052", name: "Green Gray - Medium", hex: "#959F85" },
  { code: "3053", name: "Green Gray", hex: "#BCC899" },
  { code: "3064", name: "Desert Sand", hex: "#CFA16F" },
  { code: "3072", name: "Beaver Gray - Very Light", hex: "#E3E3E0" },
  { code: "3078", name: "Golden Yellow - Very Light", hex: "#FFFACC" },
  { code: "3325", name: "Baby Blue - Light", hex: "#C4D7DD" },
  { code: "3326", name: "Rose - Light", hex: "#FF9AA2" },
  { code: "3328", name: "Salmon - Dark", hex: "#C83F51" },
  { code: "3340", name: "Apricot - Medium", hex: "#FF7F54" },
  { code: "3341", name: "Apricot", hex: "#FF9F76" },
  { code: "3345", name: "Hunter Green - Dark", hex: "#5E8C5E" },
  { code: "3346", name: "Hunter Green", hex: "#799065" },
  { code: "3347", name: "Yellow Green - Medium", hex: "#97A462" },
  { code: "3348", name: "Yellow Green - Light", hex: "#CBD195" },
  { code: "3350", name: "Dusty Rose - Ultra Dark", hex: "#B94E68" },
  { code: "3354", name: "Dusty Rose - Light", hex: "#F8C8D0" },
  { code: "3362", name: "Pine Green - Dark", hex: "#708563" },
  { code: "3363", name: "Pine Green - Medium", hex: "#869B7A" },
  { code: "3364", name: "Pine Green", hex: "#9FAA8E" },
  { code: "3371", name: "Black Brown", hex: "#2F1E1A" },
  { code: "3607", name: "Plum - Light", hex: "#DB67A0" },
  { code: "3608", name: "Plum - Very Light", hex: "#F8A9CC" },
  { code: "3609", name: "Plum - Ultra Light", hex: "#FFD2E7" },
  { code: "3685", name: "Mauve - Very Dark", hex: "#993366" },
  { code: "3687", name: "Mauve", hex: "#D47FA2" },
  { code: "3688", name: "Mauve - Medium", hex: "#E89CB4" },
  { code: "3689", name: "Mauve - Light", hex: "#FFC5D3" },
  { code: "3705", name: "Melon - Dark", hex: "#FF6B83" },
  { code: "3706", name: "Melon - Medium", hex: "#FF889B" },
  { code: "3708", name: "Melon - Light", hex: "#FFADB9" },
  { code: "3712", name: "Salmon - Medium", hex: "#E28686" },
  { code: "3713", name: "Salmon - Very Light", hex: "#FFCBC9" },
  { code: "3716", name: "Dusty Rose - Very Light", hex: "#FFCDD5" },
  { code: "3721", name: "Shell Pink - Dark", hex: "#985569" },
  { code: "3722", name: "Shell Pink - Medium", hex: "#A66A77" },
  { code: "3726", name: "Antique Mauve - Dark", hex: "#9D6B75" },
  { code: "3727", name: "Antique Mauve - Light", hex: "#D1A7B0" },
  { code: "3731", name: "Dusty Rose - Very Dark", hex: "#DC5B6F" },
  { code: "3733", name: "Dusty Rose", hex: "#F299A6" },
  { code: "3740", name: "Antique Violet - Dark", hex: "#916F98" },
  { code: "3743", name: "Antique Violet - Very Light", hex: "#DEDDE5" },
  { code: "3746", name: "Blue Violet - Dark", hex: "#725CA1" },
  { code: "3747", name: "Blue Violet - Very Light", hex: "#E5E9F4" },
  { code: "3750", name: "Antique Blue - Very Dark", hex: "#2F5467" },
  { code: "3752", name: "Antique Blue - Very Light", hex: "#C7D8DD" },
  { code: "3753", name: "Antique Blue - Ultra Very Light", hex: "#E3EFF2" },
  { code: "3755", name: "Baby Blue", hex: "#90B8D4" },
  { code: "3756", name: "Baby Blue - Ultra Very Light", hex: "#EFF5F7" },
  { code: "3760", name: "Wedgwood - Medium", hex: "#5990A8" },
  { code: "3761", name: "Sky Blue - Light", hex: "#D3EBEC" },
  { code: "3765", name: "Peacock Blue - Very Dark", hex: "#2D6E81" },
  { code: "3766", name: "Peacock Blue - Light", hex: "#7FADB4" },
  { code: "3768", name: "Gray Green - Dark", hex: "#5F7A7B" },
  { code: "3770", name: "Tawny - Very Light", hex: "#FFEDDD" },
  { code: "3771", name: "Terra Cotta - Ultra Very Light", hex: "#F5D4C7" },
  { code: "3772", name: "Desert Sand - Very Dark", hex: "#A4826B" },
  { code: "3773", name: "Desert Sand - Medium", hex: "#C5A581" },
  { code: "3774", name: "Desert Sand - Very Light", hex: "#F0E1CE" },
  { code: "3776", name: "Mahogany - Light", hex: "#DB7F55" },
  { code: "3777", name: "Terra Cotta - Very Dark", hex: "#8C3731" },
  { code: "3778", name: "Terra Cotta - Light", hex: "#D78B7D" },
  { code: "3779", name: "Terra Cotta - Ultra Very Light", hex: "#FAE0D7" },
  { code: "3781", name: "Mocha Brown - Dark", hex: "#7D5E3E" },
  { code: "3782", name: "Mocha Brown - Light", hex: "#D2B89F" },
  { code: "3787", name: "Brown Gray - Dark", hex: "#6D6560" },
  { code: "3790", name: "Beige Gray - Ultra Dark", hex: "#8D7D71" },
  { code: "3799", name: "Pewter Gray - Very Dark", hex: "#4A4A4A" },
  { code: "3801", name: "Christmas Red - Very Dark", hex: "#B51C39" },
  { code: "3802", name: "Antique Mauve - Very Dark", hex: "#6D425B" },
  { code: "3803", name: "Mauve - Dark", hex: "#A4446E" },
  { code: "3804", name: "Cyclamen Pink - Dark", hex: "#CE1E5A" },
  { code: "3805", name: "Cyclamen Pink", hex: "#E92964" },
  { code: "3806", name: "Cyclamen Pink - Light", hex: "#FF95B4" },
  { code: "3807", name: "Cornflower Blue", hex: "#6483A3" },
  { code: "3808", name: "Turquoise - Ultra Very Dark", hex: "#2E7D7D" },
  { code: "3809", name: "Turquoise - Very Dark", hex: "#3A9092" },
  { code: "3810", name: "Turquoise - Dark", hex: "#469FA2" },
  { code: "3811", name: "Turquoise - Very Light", hex: "#C8E1E1" },
  { code: "3812", name: "Sea Green - Very Dark", hex: "#2D8381" },
  { code: "3813", name: "Blue Green - Light", hex: "#A9D3C7" },
  { code: "3814", name: "Aquamarine", hex: "#4D9E8A" },
  { code: "3815", name: "Celadon Green - Dark", hex: "#3E6F5C" },
  { code: "3816", name: "Celadon Green", hex: "#5D9178" },
  { code: "3817", name: "Celadon Green - Light", hex: "#91BCA8" },
  { code: "3818", name: "Emerald Green - Ultra Very Dark", hex: "#0D5435" },
  { code: "3819", name: "Moss Green - Light", hex: "#E3E87F" },
  { code: "3820", name: "Straw - Dark", hex: "#D8A747" },
  { code: "3821", name: "Straw", hex: "#E8B953" },
  { code: "3822", name: "Straw - Light", hex: "#F6CD5B" },
  { code: "3823", name: "Yellow - Ultra Pale", hex: "#FFFFE3" },
  { code: "3824", name: "Apricot - Light", hex: "#FFB8A0" },
  { code: "3825", name: "Pumpkin - Pale", hex: "#FFBD7F" },
  { code: "3826", name: "Golden Brown", hex: "#AC7641" },
  { code: "3827", name: "Golden Brown - Pale", hex: "#F0A870" },
  { code: "3828", name: "Hazelnut Brown", hex: "#C78652" },
  { code: "3829", name: "Old Gold - Very Dark", hex: "#A88347" },
  { code: "3830", name: "Terra Cotta", hex: "#C9634A" },
  { code: "3831", name: "Raspberry - Dark", hex: "#B84866" },
  { code: "3832", name: "Raspberry - Medium", hex: "#DC6981" },
  { code: "3833", name: "Raspberry - Light", hex: "#ED92A4" },
  { code: "3834", name: "Grape - Dark", hex: "#755084" },
  { code: "3835", name: "Grape - Medium", hex: "#9069A0" },
  { code: "3836", name: "Grape - Light", hex: "#B899BD" },
  { code: "3837", name: "Lavender - Ultra Dark", hex: "#733E70" },
  { code: "3838", name: "Lavender Blue - Dark", hex: "#4F6E95" },
  { code: "3839", name: "Lavender Blue - Medium", hex: "#7198BA" },
  { code: "3840", name: "Lavender Blue - Light", hex: "#A7C2D9" },
  { code: "3841", name: "Baby Blue - Pale", hex: "#CCDDDF" },
  { code: "3842", name: "Wedgwood - Very Dark", hex: "#2A5D70" },
  { code: "3843", name: "Electric Blue", hex: "#1AB0D4" },
  { code: "3844", name: "Turquoise - Bright", hex: "#14A5B2" },
  { code: "3845", name: "Turquoise - Medium Bright", hex: "#20B7C3" },
  { code: "3846", name: "Turquoise - Light Bright", hex: "#5DD4DD" },
  { code: "3847", name: "Teal Green - Dark", hex: "#2D9186" },
  { code: "3848", name: "Teal Green - Medium", hex: "#4FA391" },
  { code: "3849", name: "Teal Green - Light", hex: "#6FBBAA" },
  { code: "3850", name: "Green - Bright", hex: "#329B74" },
  { code: "3851", name: "Green - Light Bright", hex: "#48B989" },
  { code: "3852", name: "Straw - Very Dark", hex: "#C99746" },
  { code: "3853", name: "Autumn Gold - Dark", hex: "#E69445" },
  { code: "3854", name: "Autumn Gold - Medium", hex: "#F0A859" },
  { code: "3855", name: "Autumn Gold - Light", hex: "#FAC277" },
  { code: "3856", name: "Mahogany - Ultra Very Light", hex: "#FFCBA0" },
  { code: "3857", name: "Rosewood - Dark", hex: "#824444" },
  { code: "3858", name: "Rosewood - Medium", hex: "#9F5E5E" },
  { code: "3859", name: "Rosewood - Light", hex: "#BA9393" },
  { code: "3860", name: "Cocoa", hex: "#866F66" },
  { code: "3861", name: "Cocoa - Light", hex: "#BCAA9E" },
  { code: "3862", name: "Mocha Beige - Dark", hex: "#977C5E" },
  { code: "3863", name: "Mocha Beige - Medium", hex: "#B29774" },
  { code: "3864", name: "Mocha Beige - Light", hex: "#D0BFA1" },
  { code: "3865", name: "Winter White", hex: "#F8F5F0" },
  { code: "3866", name: "Mocha Brown - Ultra Very Light", hex: "#FAEADB" },
]
